import { globalGetService } from '@/utils/globalApiServices';
import { ValidationRule } from './types';

export const getValidationRules = async (query: {
  entityType: 'CSP' | 'BRAND';
}): Promise<ValidationRule[]> => {
  const response = await globalGetService(`csp/validationRule`, query);
  return response?.ok ? response.data.records : [];
};
